import { render, staticRenderFns } from "./ReportTemplateSectionsModal.vue?vue&type=template&id=1fff2cfe&"
import script from "./ReportTemplateSectionsModal.vue?vue&type=script&lang=ts&"
export * from "./ReportTemplateSectionsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports